import { render, staticRenderFns } from "./SelectCweModal.vue?vue&type=template&id=2e1b9364&"
import script from "./SelectCweModal.vue?vue&type=script&lang=js&"
export * from "./SelectCweModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1b9364')) {
      api.createRecord('2e1b9364', component.options)
    } else {
      api.reload('2e1b9364', component.options)
    }
    module.hot.accept("./SelectCweModal.vue?vue&type=template&id=2e1b9364&", function () {
      api.rerender('2e1b9364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/SelectCweModal.vue"
export default component.exports